import { Injectable } from '@angular/core';
import { ApiBaseService } from '../../api-base.service';
import { Observable } from 'rxjs';
import { IUserProfile,IUserPassword,IPasswordUpdateResponse } from 'src/app/components/userprofile/models/user-profile.model';
import { ResponseModel } from 'src/app/common/models/ResponseModel';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private apiBaseService: ApiBaseService) { }

  getProfileDetails(): Observable<ResponseModel<IUserProfile>> {
    return this.apiBaseService.get<ResponseModel<IUserProfile>>("/api/customer", [], null);
  }

  updateProfile(profile: IUserProfile): Observable<ResponseModel<any>> {
    return this.apiBaseService.update<ResponseModel<any>>("/api/customer",null ,profile);
  }

  updatePassword(password: IUserPassword): Observable<IPasswordUpdateResponse> {
    return this.apiBaseService.update<IPasswordUpdateResponse>("/api/customer/updatePassword", null, password);
  }
}
